import { Checkbox, Container, FormControlLabel, FormHelperText, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import * as yup from 'yup';
import { PatientCompleteWizardType } from '../ui/WizardStep.tsx';
import { defaultInclusionInfo, defaultPatientSummary, PatientSummary } from '../../store/patientsSlice.ts';
import { PatientInclusionInfo } from './PatientInfoInclusion.tsx';

const PatientCompleteWizardStep5: PatientCompleteWizardType = ({ formik }) => {
  const patient: PatientSummary = {
    ...defaultPatientSummary,
    inclusionInfo: {
      ...defaultInclusionInfo,
      ...formik.values,
    },
  };

  return (
    <Container>
      <Typography align="center" gutterBottom variant="h5">
        Récapitulatif des informations d'inclusion
      </Typography>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PatientInclusionInfo editMode={false} patient={patient} />
        </Grid>
        <Grid size={8}>
          <FormControlLabel
            control={
              <Checkbox checked={formik.values.validated} name="formValidated" onChange={() => formik.setFieldValue('validated', !formik.values.validated)} />
            }
            label="Je valide les informations d'inclusion"
          />
          {formik.touched.validated && formik.errors.validated && <FormHelperText error>{formik.errors.validated}</FormHelperText>}
        </Grid>
      </Grid>
    </Container>
  );
};
PatientCompleteWizardStep5.label = 'Résumé et mise à jour';

PatientCompleteWizardStep5.initialValues = {
  validated: false,
};

PatientCompleteWizardStep5.validationSchema = yup.object().shape({
  validated: yup.boolean().oneOf([true], "Vous devez valider les informations d'inclusion pour continuer"),
});

export default PatientCompleteWizardStep5;
